"use client";
import { useState, useEffect } from "react";

/**
 * @deprecated use useBreakpointV3
 */
const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState<boolean>(false);

    useEffect(() => {
        const mediaQuery = window.matchMedia("(max-width: 768px)");
        setIsMobile(mediaQuery.matches);
    }, []);

    useEffect(() => {
        const mediaQuery = window.matchMedia("(max-width: 768px)");
        const handleResize = () => setIsMobile(mediaQuery.matches);

        mediaQuery.addEventListener("change", handleResize);
        return () => {
            mediaQuery.removeEventListener("change", handleResize);
        };
    }, []);

    return isMobile;
};

export const useIsMobileV2 = () => {
    try {
        return !matchMedia("(hover: hover)").matches;
    } catch {
        // Assume that if browser too old to support
        // matchMedia it's likely not a touch device
        return false;
    }
};

type Breakpoint = "sm" | "md" | "lg" | "xl" | "2xl";
/**
 * @deprecated use useBreakpointV3
 */
const breakpoints: Record<Breakpoint, number> = {
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    "2xl": 1536,
};

export const useBreakpoint = (breakpoint: Breakpoint) => {
    const [isBreakpoint, setIsBreakpoint] = useState<boolean | undefined>();

    useEffect(() => {
        const mediaQuery = window.matchMedia(
            `(max-width: ${breakpoints[breakpoint]}px)`,
        );
        setIsBreakpoint(mediaQuery.matches);
    }, [breakpoint]);

    useEffect(() => {
        const mediaQuery = window.matchMedia(
            `(max-width: ${breakpoints[breakpoint]}px)`,
        );
        const handleResize = () => setIsBreakpoint(mediaQuery.matches);

        mediaQuery.addEventListener("change", handleResize);
        return () => {
            mediaQuery.removeEventListener("change", handleResize);
        };
    }, [breakpoint]);

    return isBreakpoint;
};

// This fixes a bug where the usage was inverted, since will only use in V3, we'll delete the old one
export const useBreakpointV3 = (breakpoint: Breakpoint) => {
    const [isAboveBreakpoint, setIsAboveBreakpoint] = useState(true);

    useEffect(() => {
        const mediaQuery = window.matchMedia(
            `(min-width: ${breakpoints[breakpoint] + 1}px)`, // Inverted condition
        );
        setIsAboveBreakpoint(mediaQuery.matches);
    }, [breakpoint]);

    useEffect(() => {
        const mediaQuery = window.matchMedia(
            `(min-width: ${breakpoints[breakpoint] + 1}px)`, // Inverted condition
        );
        const handleResize = () => setIsAboveBreakpoint(mediaQuery.matches);

        mediaQuery.addEventListener("change", handleResize);
        return () => {
            mediaQuery.removeEventListener("change", handleResize);
        };
    }, [breakpoint]);

    return isAboveBreakpoint;
};

export default useIsMobile;
